import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from './layouts/Layout.vue';
import ErrorView from './views/Error.vue';
import LoginView from './views/LoginView.vue';
import PasswordRecoveryView from './views/PasswordRecoveryView.vue';
import SignupView from './views/SignupView.vue';
import { rudderAnalyticsPage } from './services/util/rudderstack';

export function createRouter(): VueRouter {
    Vue.use(VueRouter);

    const router = new VueRouter({
        mode: 'history',
        routes: [
            {
                path: '/',
                component: Layout,
                redirect: { name: 'login' },
                children: [
                    {
                        path: '/login',
                        name: 'login',
                        component: LoginView,
                    },
                    {
                        path: '/password/recovery',
                        name: 'password.recovery',
                        component: PasswordRecoveryView,
                    },
                    {
                        path: '/signup',
                        name: 'signup',
                        component: SignupView,
                    },
                ],
            },

            {
                path: '/error',
                alias: '/*',
                name: 'error',
                component: ErrorView,
            },
        ],
    });

    router.afterEach((to, from) => {
        rudderAnalyticsPage('login', to.name, {
            from: from.fullPath,
            to: to.fullPath,
        });
    });

    return router;
}
